<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <div class="flex justify-between items-center">
        <div class="top-txt">
          <h4><b>Company Dashboard</b></h4>
        </div>

        <!-- <a
          href="#"
          class=""
          @click.prevent="
            downloadItem({
              url: '../assets/images/CG_template.xlsx',
              label: 'example.png',
            })
          "
        >
          Download Sample File
        </a> -->

        <!-- <b-button disabled size="lg" class="border-solid border-2"
          >Download Sample File</b-button
        > -->
        <div class="flex flex-col">
          <base-button
            outline
            class="px-6 py-1 mx-1 mb-2 flex"
            type="primary"
            v-b-modal.modal-lg
          >
            <span class="btn-inner--text flex items-center">+ Add File</span>
          </base-button>
          <a
            href="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/default/CG-template.xlsx"
            target="_blank"
            download
          >
            <base-button outline class="px-6 py-1 mx-1" type="primary">
              Download Sample File
            </base-button></a
          >
        </div>

        <b-modal id="modal-lg" size="lg" centered title="" hide-footer>
          <p class="my-4">
            <!-- <b-button @click="onFileChange()">Upload File</b-button> -->
            <input type="file" @change="onFileChange" />
            <!-- <b-form-file
              v-model="file1"
              drop-placeholder="Drop file here..."
              accept=".doc,.docx,.pdf,.txt,.xlsx"
              >Upload File</b-form-file
            > -->

            <el-table
              @selection-change="handleSelectionChange"
              class="table-responsive table-flush mt-6"
              header-row-class-name="thead-light table-th-color"
              :data="displayedPages"
            >
              <el-table-column label="Accept all" min-width="250px" sortable>
                <b-form-group>
                  <template #label>
                    <b-form-checkbox
                      v-model="allSelected"
                      :indeterminate="indeterminate"
                      aria-describedby="flavours"
                      @change="toggleAll"
                    >
                      {{ allSelected ? "Un-select-All" : "Select All" }}
                    </b-form-checkbox>
                  </template>
                  <template v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group
                      id="flavours"
                      v-model="selected"
                      :options="flavours"
                      :aria-describedby="ariaDescribedby"
                      name="flavours"
                      class="ml-4"
                      aria-label="Individual flavors"
                      stacked
                    >
                    </b-form-checkbox-group>
                  </template>
                </b-form-group>
              </el-table-column>

              <template v-slot="{}">
                <b-media no-body class="align-items-center">
                  <a href="#" class="w-3/5 mr-3">
                    <div>
                      Selected:<strong>{{ selected }}</strong> All
                      Selected:<strong>{{ allSelected }}</strong
                      ><br />
                      Indetermiante:<strong>{{ indetermiante }}</strong>
                    </div>
                  </a>
                </b-media>
              </template>
            </el-table>

            <el-table
              class="table-responsive table-flush mt-6"
              header-row-class-name="thead-light table-th-color"
              :data="excel_content"
            >
              <el-table-column
                label="Sr No"
                min-width="100px"
                prop="Srno"
                sortable
              >
                <template v-slot="{ row }">
                  <span class="text-black font-medium">{{ row.no }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="Name"
                min-width="100px"
                prop="name"
                sortable
              >
                <template v-slot="{ row }">
                  <span class="text-black font-medium">{{ row.name }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="Email"
                min-width="170px"
                prop="orderno"
                sortable
              >
                <template v-slot="{ row }">
                  <span class="text-black font-medium">{{ row.email }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="Mobile No."
                prop="mobile"
                min-width="140px"
                sortable
              >
                <template v-slot="{ row }">
                  <span class="text-black">{{ row.mobile }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="Created Date"
                prop="date"
                min-width="140px"
                sortable
              >
                <template v-slot="{ row }">
                  <span class="text-black">{{ row.start }}</span>
                </template>
              </el-table-column>
            </el-table>
          </p>

          <div class="flex justify-end footer-btn">
            <b-button class="btn-submit" @click="onSubmit()"
              >Send Invite</b-button
            >
            <b-button class="btn-clr">Cancel</b-button>
          </div>

          <p></p>
        </b-modal>
      </div>

      <div>
        <b-avatar-group size="50px">
          <b-avatar text="i" variant="danger">
            <h5>Displays the note as the 100 of limit for uploading license</h5>
          </b-avatar>
        </b-avatar-group>
      </div>

      <b-input-group class="mt-4">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-card>
  </div>
</template>

<script>
import "@/assets/scss/Index.scss";
import CompanyData from "./CompanyData";
import axios from "axios";
// import readXlsxFile from "read-excel-file";
import emailMixin from "@/mixins/email";
import { mapState } from "vuex";
// import EditDetail from "./components/EditDetail.vue";
// import AddBannerSidebar from "./components/AddBannerSidebar.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  mixins: [emailMixin],
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    // EditDetail,
    // AddBannerSidebar
  },
  data() {
    return {
      flavours: ["1", "2", "3", "4"],
      selected: [],
      allSelected: false,
      indeterminate: false,
      CompanyData,
      editModal: false,
      openAddBannerSidebar: false,
      excel_content: [],
      currentPage: 8,
      perPage: 1,
    };
  },
  methods: {
    onFileChange(event) {
      const map = {
        No: "no",
        Name: "name",
        Email: "email",
        Mobile: "mobile",
        Start: "start",
      };

      let xlsxfile = event.target.files ? event.target.files[0] : null;
      // readXlsxFile(xlsxfile, { map }).then(({ rows }) => {
      //   // console.log("rows", rows);
      //   this.excel_content = rows;
      //   console.log(this.excel_content);
      // });
    },
    displayedPages() {
      return this.excel_content.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },

    async onSubmit(event) {
      let payload = this.excel_content;
      let loader = this.$loading();
      try {
        // for(let i = 0;i <= this.excel_content.length;i++)
        // {
        //   let temp = this.excel_content[i]
        //     const data = await this.$store.dispatch("companydash/create", temp);
        // }
        const data = await this.$store.dispatch("companydash/create", payload);
        // if (data.code === 200) {
        this.$router.push({ name: "admin-dashboard" });
        this.$swal.fire({
          title: "Created",
          text: "Data has been Added Successfully!",
          icon: "success",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // for (let [key, value] of Object.entries(this.rows)) {
        //   console.log(`${key}:${value}`);
        // }
        this.excel_content.forEach((element) => {
          // console.log(element.email);

          const bcc = ["ruchita.sngh@aiab.in"];
          const to = [element.email];
          const subject =
            "Hi " +
            element.name +
            " Welcome to Caregiver, Please Find Login Credentials!!";
          const body = `
                     <html>
        <body >
        
      <table width="100%" border="0" align="center" cellpadding="0" cellspacing="0" style="background-color:#dcfbf8">

<!-- START HEADER/BANNER -->

		<tbody><tr>
			<td align="center">
				<table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0">
					<tbody><tr>
						<td align="center" valign="top" background="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/brandimage.jpg" bgcolor="#66809b" style="   background-repeat: no-repeat; background-position:top;height="400""="">
							<table class="col-600" width="600" height="250" border="0" align="center" cellpadding="0" cellspacing="0">

								<tbody><tr>
									<td height="40"></td>
								</tr>

								<tr>
									<td height="50"></td>
								</tr>
							</tbody></table>
						</td>
					</tr>
				</tbody></table>
			</td>
		</tr>


<!-- END HEADER/BANNER -->


<!-- START 3 BOX SHOWCASE -->

		<tr>
			<td align="center">
				<table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="background-color:#FBF6F6;margin-left:20px; margin-right:20px; ">
					<tbody><tr>
						<td height="35"></td>
					</tr>

            		<tr>
						<td align="left" style="font-family: 'Raleway', sans-serif; font-size:18px;  color:#4f0a4b; padding-left:15pt;"><b>Hi</b> <span style="color:#000;">${element.name},</span></td>
					</tr>
            <tr>
						<td height="35"></td>
					</tr>
					<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:22px; font-weight: bold; color:#4f0a4b;">Welcome to Caregiver Saathi</td>
					</tr>

					<tr>
						<td height="10"></td>
					</tr>


					<tr>
						<td align="center" style="font-family: 'Lato', sans-serif; font-size:14px; color:#000; line-height:24px; font-weight: 300;padding-left:15pt;padding-right:15pt;">
						${this.user.firstname} has invited you to the Caregiver Saathi platform. Caregiver Saathi is an ecosystem of well-being for family caregivers taking care of their dear ones navigating chronic medical conditions, age related challenges or terminal illness. We are a one-stop platform offering programs, products and services that support the family caregivers through emotional aid, educational content, access to a community of experienced caregivers, support groups, counselling and professional service for home-based care.
						</td>
					</tr>

				</tbody></table>
			</td>
		</tr>
	
		

      		<tr>
			<td align="center">
				<table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="background-color:#FBF6F6;margin-left:20px; margin-right:20px; ">
					<tbody><tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:14px;text-decoration:underline;">Visit:<a href="#" target="_blank">caregiversaathi.co.in</a> </td>
					</tr>

        
         
					<tr>
						<td align="center" style="font-family: 'Lato', sans-serif; font-size:14px; color:#333; line-height:24px; font-weight: 300;padding-left:15pt;padding-right:15pt;">Please find below your login details to begin your journey with us. 
 </td>
					</tr>

           
            
               		<tr>
						<td height="20"></td>
					</tr> 			<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:16px;font-weight:bold;  color:#4f0a4b;">Username: <span style="color:#000;font-weight:300;"> ${element.mobile} </span> </td>
					</tr>
            
                      		<tr>
						<td height="10"></td>
					</tr> 			<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:16px; font-weight:bold;   color:#4f0a4b;">

Password:  <span style="color:#000; font-weight:300;"> caregiver@123 </span></td>
					</tr>
            
            
            

			

				</tbody></table>
			</td>
		</tr>
         	<tr>
			<td align="center">
				<table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="background-color:#FBF6F6;margin-left:20px; margin-right:20px;">
					<tbody><tr>
						<td height="30">You can also download our app to use our services.<br/>You can use the same credentials to login.</td>
					</tr>

        
         
					<tr>
						<td align="center" style="font-family: 'Lato', sans-serif; font-size:14px; color:#000; line-height:24px; font-weight: 300;padding-left:15pt;padding-right:15pt;">If at any point you have queries regarding your joining, feel free to reach out to us at
 </td>
					</tr>

           
            
               		<tr>
						<td height="10"></td>
					</tr> 			<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:14px;text-decoration:underline;"><a href="#" target="_blank">info@caregiversaathi.co.in</a> </td>
					</tr>
            
           
            
            
            
					<tr>
						<td height="30"></td>
					</tr>


			

				</tbody></table>
			</td>
		</tr>
      
      
  
      	<tr>
			<td align="center">
				<table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="background-color:#FBF6F6; margin-left:20px; margin-right:20px; ">
					<tbody>

        
         
					<tr>
						<td align="center" style="font-family: 'Lato', sans-serif; font-size:16px;font-weight:bold; color:#4f0a4b; line-height:24px;padding-left:15pt;padding-right:15pt;" 
>
Team Caregiver Saathi 
 </td>
					</tr>
<tr>
						<td height="10"></td>
					</tr>
           
            
             			<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:14px;text-decoration:underline;"><a href="#" target="_blank">info@caregiversaathi.co.in</a> </td>
					</tr>
            
           
            
            
            
					<tr>
						<td height="30"></td>
					</tr>


			

				</tbody></table>
			</td>
		</tr>
	
	<tr>
			<td align="center">
				<table align="center" class="col-600" width="600" border="0" cellspacing="0" cellpadding="0" style="background-color:#80d1d9; padding-bottom:10pt;">
					<tbody>	<tr>
						<td height="30"></td>
					</tr>
											<tr>
						<td align="center" style="font-family: 'Lato', sans-serif; font-size:20px;font-weight:bold; color:#4f0a4b; line-height:24px;padding-left:15pt;padding-right:15pt;" 
>
Follow us on our social media channels
 </td>
					</tr>
					<tr>
						<td height="25"></td>
					</tr>
					<tr>
						<td align="center">
				<table align="center"border="0" cellspacing="0" cellpadding="0">
								<tbody><tr>
								

									<td align="center" style="padding-right:15pt;">
										 <a href="https://www.facebook.com/caregiversaathi" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/facebook.png" width="25" height="25" /> </a>
									</td>

	                            	<td align="center" style="padding-right:15pt;">
										 <a href="https://www.twitter.com/BhavanaIssar/" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/twitter.png"  width="25" height="25" /> </a>
									</td>

                                    	<td align="center" style="padding-right:15pt;">
										 <a href="http://www.caregiversaathi.co.in/" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/share.png" width="25" height="25" /> </a>
									</td>

                                    	<td align="center" style="padding-right:15pt;">
										 <a href="https://linkedin.com/company/caregiver-saathi/" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/linkedin.png" width="25" height="25" /> </a>
									</td>
                                       	<td align="center" style="padding-right:15pt;">
										 <a href="https://www.instagram.com/caregiversaathi/" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/instagram.png" width="25" height="25" /> </a>
									</td>

									<td align="center">
											<a href="https://www.instagram.com/caregiversaathi/" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/youtube.png" width="25" height="25" /> </a>
									</td>
								</tr>
                  
                    
					<tr>
						<td height="20"></td>
					</tr>
								</tbody></table>



							</td></tr></tbody></table>
						</td>
					</tr>

   
   

  
           
            
            
            
			


			

				</tbody></table>
			</td>
		</tr>
    
      
				</tbody></table>



         </body>
         
         </html>

                 `;
          this.sendEmail(to, subject, body, [], bcc);
          // this.$refs.formValidator.reset();
        });

        loader.close();
      } catch (err) {
        loader.close();
        this.$swal.fire({
          title: "Some Mobile Number Already Register",
          text: err,
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },
    toggleAll(checked) {
      this.selected = checked ? this.flavours.slice() : [];
    },

    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
    async downloadItem({ url, label }) {
      const response = await axios.get(url, { responseType: "blob" });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
    },
  },
  watch: {
    selected(newValue, oldValue) {
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.flavours.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },

  computed: {
    ...mapState("auth", {
      user: "user",
    }),
  },
};
</script>

<style>
.top-txt {
  margin-top: 1rem;
}

.modal-header {
  padding: 0px;
}

.modal-body {
  padding-left: 1.5rem !important;
  padding: 0px;
}
.btn-submit {
  background-color: #4f0a4b;
  color: white;
}
.btn-clr {
  background-color: #4f0a4b;
  color: white;
}
.footer-btn {
  padding: 10px 20px;
}
.btn-submit:hover {
  background-color: #240422;
  color: white;
}
.btn-clr:hover {
  background-color: #4f0a4b;
  color: white;
}
.modal-body {
  padding-right: 1.5rem;
}
</style>
